import React, {Fragment, useEffect, useState} from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import NavClass from './NavClass';
import TabClass from './TabClass';
import ManageUsers from "../../../api/ManageUsers";
import ManageTransactions from "../../../api/ManageTransactions";
import {toast} from "react-toastify";

const Task = () => {
  const [transactions, setTransactions] = useState([]);


  function loadTransactions(){
    ManageTransactions.loadTransactions()
        .then(response => {
            //console.log("TRANSACTION :::: ", response.data.data);
          setTransactions(response.data.data)
        })
        .catch(error => {
            toast.error("Erreur lors du chargement des données. Réessayer plus tard.");
        })
  }

  useEffect(() => {
      loadTransactions();
  }, [])

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Gestion des transaction" parent="Gestion" title="Transactions" />
      <Container fluid={true}>
        <div className="email-wrap bookmark-wrap">
          <Row>
            {/*<NavClass newtaskdata={newtaskdata} activeToggle={activeToggle} />*/}
            <TabClass transactions={transactions} reloadAction={loadTransactions} />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default Task;